import React from "react"
import classnames from "@utils/classnames"
import styles from "./frame.module.scss"
import Button from "@components/button"

import arrowImg from "@images/arrow-down.png"
import comingImg from "@images/coming.png"

const Frame = React.memo(
  ({
    children,
    className,
    type = "outline",
    hoverEffect = false,
    clickable: clickableProp,
    withArrow = false,
    withComingSoon = false,
    ...restProps
  }) => {
    const clickable =
      typeof clickableProp === "undefined"
        ? !!(type === "button" || restProps.onClick)
        : clickableProp
    let body = children
    if (withArrow || withComingSoon) {
      body = (
        <>
          {children}
          <img
            className={withArrow ? styles.arrow : styles.coming}
            src={withArrow ? arrowImg : comingImg}
          />
        </>
      )
    }
    if (type === "dark") {
      body = <div className={styles.darkInner}>{body}</div>
    } else if (type === "button") {
      body = <span>{body}</span>
    }
    const props = {
      className: classnames(
        styles.container,
        {
          [styles.containerWithBottom]: withArrow || withComingSoon,
          [styles.containerOutline]: type === "outline",
          [styles.containerGlow]:
            (clickable || hoverEffect) && ["outline", "button"].includes(type),
          [styles.containerDark]: type === "dark",
          [styles.containerButton]: type === "button",
        },
        className
      ),
      children: body,
      clickable,
      plain: true,
      ...restProps,
    }
    return <Button {...props} />
  }
)

Frame.ButtonContainer = props => {
  return (
    <div
      {...props}
      className={classnames(styles.buttonContainer, props.className)}
    />
  )
}

Frame.OutlineContainer = props => {
  return (
    <div
      {...props}
      className={classnames(styles.outlineContainer, props.className)}
    />
  )
}

Frame.displayName = "Frame"
export default Frame
